<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            Notificações de Abonos Solicitados
          </h4>
          <div>
            <div class="row align-items-center mb-4">
              <!-- Quantidade por página -->
              <div class="col-auto">
                <el-select
                  class="select-success mb-3 pagination-select"
                  style="width:170px"
                  v-model="pagination.perPage"
                  placeholder="Por página"
                >
                  <el-option
                    class="select-success"
                    v-for="item in perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>

              <!-- Status -->
              <div class="col-auto">
                <el-select
                  class="select-success mb-3 pagination-select"
                  style="width:170px"
                  v-model="statusSelecionado"
                  @change="listarAbonos(1)"
                  placeholder="Status"
                >
                  <el-option
                    class="select-success"
                    v-for="item in statusAbonos"
                    :key="item.value"
                    :label="item.descricao"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>

              <!-- Botão -->
              <div class="col-auto">
                <base-button
                  type="success"
                  class="animation-on-hover mb-3"
                  @click="dialogCadastrarAbonos = true"
                >
                  Lançar Abonos
                </base-button>
              </div>

              <!-- Pesquisa -->
              <div class="col d-flex justify-content-end">
                <base-input>
                  <el-input
                    type="search"
                    class="mb-3 search-input"
                    style="width:280px"
                    color="success"
                    clearable
                    prefix-icon="el-icon-search"
                    placeholder="Pesquisar funcionário"
                    v-model="searchQuery"
                    aria-controls="datatables"
                  >
                  </el-input>
                </base-input>
              </div>
            </div>

            <el-table :data="searchedData">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="135" align="right" label="Ações">
                <div slot-scope="props">
                  <el-tooltip
                    content="Visualizar Abono"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click.native="visualizarSolicitacao(props.row)"
                      class="remove btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-notes"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="font-weight-normal">
                Mostrando de {{ from + 1 }} a {{ to }} no total de
                {{ total }} funcionários.
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.totalItems"
              @input="listarAbonos"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="dialogAbono">
      <template slot="header">
        <h4 class="modal-title" id="exampleModalLabel">
          Detalhes do Abono
        </h4>
      </template>
      <div class="row">
        <div class="col-12"></div>
        <div class="col-md-12 pr-md-1 text-left">
          <p><b>Funcionário: </b>{{ AbonoSelecionado.NOME }}</p>
          <p><b>Data de Criação: </b>{{ AbonoSelecionado.dt_criacao }}</p>
          <p><b>Tipo: </b>{{ AbonoSelecionado.DESCRICAO_TIPO_ABONO }}</p>
          <p><b>Data do Abono: </b>{{ AbonoSelecionado.DATA_ABONO }}</p>
          <p><b>Horas: </b>{{ AbonoSelecionado.horas }}</p>
          <p>
            <b>Status: </b>
            <input
              type="radio"
              id="S"
              value="S"
              v-model="AbonoSelecionado.status_abono"
            />
            <label
              style="border-left-width: 20px; margin-left: 10px;margin-right: 10px;"
              for="S"
              >Aprovado</label
            >
            <input
              type="radio"
              id="N"
              value="N"
              v-model="AbonoSelecionado.status_abono"
            />
            <label
              style="border-left-width: 20px; margin-left: 10px;margin-right: 10px;"
              for="N"
              >Reprovado</label
            >
            <input
              type="radio"
              id="A"
              value="A"
              v-model="AbonoSelecionado.status_abono"
            />
            <label style="border-left-width: 20px; margin-left: 10px;" for="A"
              >Aguardando aprovação</label
            >
          </p>
          <button class="btn btn-info btn-simple" @click="carregarArquivo()">
            Visualizar Arquivo
          </button>
          <div class="w-100 d-flex justify-content-end">
            <base-button type="success" @click="salvarAbono()"
              >Salvar</base-button
            >
          </div>
        </div>
      </div>
      <template slot="footer">
        <div class="w-100 d-flex justify-content-end"></div>
      </template>
    </modal>

    <modal :show.sync="dialogCadastrarAbonos">
      <template slot="header">
        <h4 class="modal-title">
          Cadastrar Abono
        </h4>
      </template>

      <div class="row">
        <div class="col-12 text-left mb-3">
          <base-checkbox v-model="novaAbono.todos">
            Todos os funcionários
          </base-checkbox>
        </div>

        <div class="col-12 mb-3">
          <el-select
            class="w-100"
            :class="
              block.funcionarios === true ? 'has-danger' : 'select-success'
            "
            v-model="novaAbono.funcionarios"
            multiple
            filterable
            clearable
            placeholder="Selecionar funcionário"
            :disabled="novaAbono.todos"
          >
            <el-option
              v-for="funcionario in funcionarios"
              :key="`${funcionario.id}-${funcionario.matricula || ''}`"
              :label="funcionario.nome"
              :value="`${funcionario.id}|${funcionario.matricula || ''}`"
            >
            </el-option>
          </el-select>
        </div>

        <div class="col-12 mb-3">
          <el-select
            class="w-100"
            :class="block.tipoAbono === true ? 'has-danger' : 'select-success'"
            v-model="novaAbono.id_tipo_abono"
            clearable
            placeholder="Selecionar Abono"
          >
            <el-option
              v-for="abono in tiposAbonos"
              :key="abono.id"
              :label="abono.descricao"
              :value="abono.id"
            >
            </el-option>
          </el-select>
        </div>

        <div class="col-6 text-left">
          <base-input label="Data Inicial">
            <el-input
              :class="block.data_inicial === true ? 'has-danger' : ''"
              type="date"
              placeholder="dd/mm/aaaa"
              v-model="novaAbono.data_inicial"
              @blur="validarData(novaAbono.data_inicial)"
            />
          </base-input>
        </div>

        <div class="col-6 text-left">
          <base-input label="Data Final">
            <el-input
              :class="block.data_final === true ? 'has-danger' : ''"
              type="date"
              placeholder="dd/mm/aaaa"
              v-model="novaAbono.data_final"
              @blur="validarData(novaAbono.data_final)"
            />
          </base-input>
        </div>

        <div class="col-12 text-left">
          <base-input label="Qtde. de horas a abonar">
            <el-input
              :class="block.horas === true ? 'has-danger' : ''"
              v-mask="'##:##'"
              placeholder="00:00"
              v-model="novaAbono.horas"
            />
          </base-input>
        </div>
      </div>

      <template slot="footer">
        <div class="row w-100">
          <div class="col-6">
            <base-button
              type="danger"
              class="w-100"
              @click="dialogCadastrarAbonos = false"
            >
              Fechar
            </base-button>
          </div>

          <div class="col-6">
            <base-button
              type="success"
              class="w-100"
              @click="salvarVariosAbonos()"
            >
              Enviar Abono
            </base-button>
          </div>
        </div>
      </template>
    </modal>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput, BaseRadio } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import NotificationHorarioLimite from "../pages/Notifications/NotificationHorarioLimite.vue";
import Modal from "@/components/Modal.vue";
import axios from "axios";
import moment from "moment";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.totalItems;
    },
  },
  data() {
    return {
      dialogCadastrarAbonos: false,
      novaAbono: {
        todos: false,
        funcionarios: [],
        data_inicial: null,
        data_final: null,
        horas: "",
        id_tipo_abono: null,
        modo_abono: 2,
        status_abono: "A",
      },
      funcionarios: [],
      tiposAbonos: [],

      block: {
        tipoAbono: false,
        horas: false,
        funcionarios: false,
        data_final: "",
        data_inicial: "",
      },

      perPageOptions: [10, 50, 100],
      pagination: {
        currentPage: 1,
        perPage: 100,
        totalItems: 0,
        totalPages: 0,
      },
      dadosUsuario: "",
      isLoading: false,
      searchQuery: "",
      propsToSearch: ["NOME"],
      tableColumns: [
        {
          prop: "NOME",
          label: "Nome",
          minWidth: 300,
        },
        {
          prop: "matricula",
          label: "Matricula",
          minWidth: 100,
        },
        {
          prop: "DESCRICAO_TIPO_ABONO",
          label: "Descrição",
          minWidth: 300,
        },
        {
          prop: "DATA_ABONO",
          label: "Data do Abono",
          minWidth: 100,
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      dialogAbono: false,
      AbonoSelecionado: "",
      abortController: null,
      debounceTimeout: null,
      statusAbonos: [
        { descricao: "Aprovado", value: "S" },
        { descricao: "Reprovado", value: "N" },
        { descricao: "Aguardando", value: "A" },
      ],
      statusSelecionado: { descricao: "Aguardando", value: "A" }, //inicializa com status para aprovar
    };
  },
  mounted() {
    this.carregarDadosUsuario();
    this.listarAbonos();
    this.listarFuncionarios();
    this.listarTipoAbono();
  },
  methods: {
    moment: function(data) {
      return moment(data);
    },
    validarData(dataEnviada) {
      if (!dataEnviada) {
        return false;
      }
      const anoAtual = this.moment().year();

      const dataValida = this.moment(dataEnviada).isValid();
      const ano = Number(dataEnviada.split("-")[0]);

      if (!dataValida || ano < 1900 || ano > anoAtual) {
        this.showSwal(
          "auto-close",
          "Data inválida",
          "Informe uma data válida.",
          "error",
        );

        return false;
      }

      return true;
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        return Swal.fire({
          title: title,
          text: text,
          icon: typeMsg, // SweetAlert2 usa 'icon' em vez de 'type'
          timer: 2000,
          showConfirmButton: false,
        });
      } else if (type === "confirmation") {
        return Swal.fire({
          title: title,
          text: text,
          icon: typeMsg, // SweetAlert2 usa 'icon' em vez de 'type'
          showCancelButton: true,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
        });
      }
    },
    carregarDadosUsuario() {
      this.dadosUsuario = this.$cookies.get("usuario") || null;
    },
    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000,
      });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 2000,
          showConfirmButton: false,
        });
      }
    },

    async listarAbonos(page = 1) {
      if (this.abortController) {
        this.abortController.abort(); // Cancela a requisição anterior
      }
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.isLoading = true;

      let bodyFormData = {
        query: this.searchQuery,
        setDB: this.$cookies.get("db"),
        idUsuario: "",
        page,
        limit: this.pagination.perPage,
        status: this.statusSelecionado.value,
      };

      if (this.dadosUsuario) {
        bodyFormData.idUsuario = this.dadosUsuario.id;
      }

      try {
        const response = await this.axios.post(
          "/api/abonos/listarAbonos",
          bodyFormData,
          {
            signal,
          },
        );
        this.isLoading = false;
        if (response.data.data.abonos.length > 0) {
          this.searchedData = response.data.data.abonos;
          this.pagination = response.data.data.pagination;
        } else {
          this.searchedData = [];
        }
      } catch (error) {
        this.isLoading = false;
        if (axios.isCancel(error)) {
          console.log("Requisição cancelada:", error.message);
        } else {
          console.error("Erro na requisição:", error);
          this.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar Solicitação de Abono!",
            "error",
          );
        }
      }
    },

    async listarFuncionarios() {
      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        idUsuario: "",
      };

      if (this.dadosUsuario) {
        bodyFormData.idUsuario = this.dadosUsuario.id;
      }

      try {
        const response = await this.axios.post(
          "/api/empregado/listarEmpregados3",
          bodyFormData,
          {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        );

        if (response.data.data.length > 0) {
          this.funcionarios = response.data.data;
        } else {
          this.funcionarios = [];
        }
      } catch (error) {
        console.error("Erro na requisição:", error);
        this.showSwal(
          "auto-close",
          "Erro",
          "Erro ao listar Funcionários!",
          "error",
        );
      }
    },

    listarTipoAbono() {
      let th = this;

      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        ativo: "S",
      };

      this.axios
        .post("/api/abonos/listarTiposDeAbonos", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.tiposAbonos = response.data.data.dados;
        })
        .catch((err) => {
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao carregar tipos de abonos!",
            "error",
          );
        });
    },

    editarSolicitacao(valor, row) {
      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: row.id,
        status_abono: valor,
      };

      const that = this;
      this.isLoading = true;

      this.axios
        .post("/api/abonos/atualizarStatusAbono", bodyFormData)
        .then((response) => {
          console.log(response.data);
          that.isLoading = false;

          that.showSwal(
            "auto-close",
            "Sucesso",
            `A Solicitação foi ${
              valor === "S" ? "Aprovada" : "Recusada"
            } com Sucesso!`,
            "success",
          );
          that.listarAbonos();
        })
        .catch((err) => {
          console.log(err);
          that.isLoading = false;
          that.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar Atualizar Status do Abono!",
            "error",
          );
        });
    },
    visualizarSolicitacao(row) {
      this.dialogAbono = true;
      this.AbonoSelecionado = row;
    },
    statusAbono() {
      if (this.AbonoSelecionado !== "") {
        if (this.AbonoSelecionado.status_abono === "A") return "Aguardando";
        if (this.AbonoSelecionado.status_abono === "S") return "Aprovado";
        if (this.AbonoSelecionado.status_abono === "N") return "Reprovado";
        else return "Aguardando";
      } else return "";
    },
    carregarArquivo() {
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: this.AbonoSelecionado.id,
      };

      this.isLoading = true;
      const that = this;

      this.axios
        .post("/api/abonos/listarArquivo", bodyFormData)
        .then((response) => {
          that.isLoading = false;

          if (response.data.data.arquivo.length > 0) {
            that.AbonoSelecionado.arquivo = response.data.data.arquivo;
            that.abrirArquivo();
          } else {
            that.AbonoSelecionado.arquivo = "";
          }
        })
        .catch((err) => {
          that.AbonoSelecionado.arquivo = "";
          console.log(err);
          that.isLoading = false;
          that.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar Arquivo de Abono!",
            "error",
          );
        });
    },
    abrirArquivo() {
      const arquivo = this.AbonoSelecionado.arquivo;

      if (String(arquivo).substring(0, 10) === "data:image") {
        // abre a imagem em uma nova guia
        var image = new Image();
        image.src = arquivo;

        var w = window.open("");
        w.document.write(image.outerHTML);
      } else if (String(arquivo).substring(0, 20) === "data:application/pdf") {
        // se for um PDF, abre em uma nova guia
        var w = window.open("");

        w.document.write(
          '<iframe src="' + arquivo + '" width="100%" height="100%"></iframe>',
        );
      } else {
        // se for outro tipo de arquivo, então baixar

        window.open(arquivo);
      }
    },

    aprovarSolicitacao(row) {
      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: row.id,
        status_abono: "S",
      };

      const that = this;
      this.isLoading = true;

      this.axios
        .post("/api/abonos/atualizarStatusAbono", bodyFormData)
        .then((response) => {
          console.log(response.data);
          that.isLoading = false;

          that.showSwal(
            "auto-close",
            "Sucesso",
            `A Solicitação foi Aprovada com Sucesso!`,
            "success",
          );
          that.listarAbonos();
          this.dialogAbono = false;
        })
        .catch((err) => {
          console.log(err);
          that.isLoading = false;
          that.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar Atualizar Status do Abono!",
            "error",
          );
        });
    },
    reprovarSolicitacao(row) {
      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: row.id,
        status_abono: "N",
      };

      const that = this;
      this.isLoading = true;

      this.axios
        .post("/api/abonos/atualizarStatusAbono", bodyFormData)
        .then((response) => {
          console.log(response.data);
          that.isLoading = false;

          that.showSwal(
            "auto-close",
            "Sucesso",
            `A Solicitação foi Reprovada com Sucesso!`,
            "success",
          );
          that.listarAbonos();
          this.dialogAbono = false;
        })
        .catch((err) => {
          console.log(err);
          that.isLoading = false;
          that.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar Atualizar Status do Abono!",
            "error",
          );
        });
    },

    salvarAbono() {
      if (!this.AbonoSelecionado.status_abono) {
        alert("Selecione um status antes de salvar.");
        return;
      }

      const status = this.AbonoSelecionado.status_abono;
      let mensagemConfirmacao;
      if (status === "S") {
        swal({
          title: "Tem certeza?",
          text: `Deseja realmente Aprovar abono ?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Sim",
          cancelButtonText: "Não!",
          buttonsStyling: false,
        })
          .then((response) => {
            if (response.value) {
              this.aprovarSolicitacao(this.AbonoSelecionado);
            }
          })
          .catch((err) => {});
        //this.aprovarSolicitacao(this.AbonoSelecionado);
      } else if (status === "N") {
        swal({
          title: "Tem certeza?",
          text: `Deseja realmente Reprovar abono ?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Sim",
          cancelButtonText: "Não!",
          buttonsStyling: false,
        })
          .then((response) => {
            if (response.value) {
              this.reprovarSolicitacao(this.AbonoSelecionado);
            }
          })
          .catch((err) => {});
        //this.reprovarSolicitacao(this.AbonoSelecionado);
      } else if (status === "A") {
        this.showSwal(
          "auto-close",
          "Atenção",
          "O status 'Aguardando' não requer ação de salvar.",
          "info",
        );
        return;
      } else {
        alert("Status inválido.");
        return;
      }
    },
    async salvarVariosAbonos() {
      if (this.validarCampos()) {
        try {
          this.isLoading = true;

          const funcionariosSelecionados = this.novaAbono.funcionarios.map(
            (item) => {
              const [id, matricula] = item.split("|");

              return {
                id: Number(id),
                matricula: matricula || null,
              };
            },
          );

          const payload = {
            setDB: this.$cookies.get("db"),
            todos: this.novaAbono.todos,
            abono: {
              data_inicial: this.novaAbono.data_inicial,
              data_final: this.novaAbono.data_final,
              horas: `${this.novaAbono.horas}:00`,
              id_tipo_abono: this.novaAbono.id_tipo_abono,
              modo_abono: 2,
              status_abono: "S",
              arquivo: "",
            },
            funcionarios: this.novaAbono.todos ? [] : funcionariosSelecionados,
            idUsuario: this.dadosUsuario ? this.dadosUsuario.id : null,
          };

          const response = await this.axios.post(
            "/api/abonos/solicitarAbonos",
            payload,
            {
              headers: {
                "id-actor": this.$cookies.get("id_actor"),
                "tipo-actor": this.$cookies.get("tipo_actor"),
              },
            },
          );

          if (response.data.status == "success") {
            this.showSwal(
              "auto-close",
              "Sucesso",
              `A Solicitação de Abono foi enviada com Sucesso!`,
              "success",
            );
          } else {
            this.showSwal(
              "auto-close",
              "Erro",
              "Erro ao Cadastrar Abonos",
              "error",
            );
          }
        } catch (error) {
          console.error("Erro na requisição:", error);
          this.showSwal(
            "auto-close",
            "Erro",
            "Erro ao Cadastrar Abonos!",
            "error",
          );
        } finally {
          this.limparCamposAbonos();
          this.isLoading = false;
        }
      }
    },
    limparCamposAbonos() {
      this.dialogCadastrarAbonos = false;
      this.novaAbono = {
        todos: false,
        funcionarios: [],
        data_inicial: null,
        data_final: null,
        horas: "",
        id_tipo_abono: null,
        modo_abono: 2,
        status_abono: "A",
      };
    },
    validarCampos() {
      let status = true;

      // validando datas
      if (this.novaAbono.data_final == "") {
        this.block.data_final = true;
        status = false;
      } else {
        this.block.data_final = false;
      }

      if (this.novaAbono.data_inicial == "") {
        this.block.data_inicial = true;
        status = false;
      } else {
        this.block.data_inicial = false;
      }

      if (!this.validarData(this.novaAbono.data_inicial)) {
        this.block.data_inicial = true;
        status = false;
      } else {
        this.block.data_inicial = false;
      }

      if (!this.validarData(this.novaAbono.data_final)) {
        this.block.data_final = true;
        status = false;
      } else {
        this.block.data_final = false;
      }

      if (!this.novaAbono.horas || this.novaAbono.horas == "") {
        this.block.horas = true;
        status = false;
      } else {
        this.block.horas = false;
      }

      if (!this.novaAbono.todos && !this.novaAbono.funcionarios.length) {
        this.block.funcionarios = true;
        status = false;
      } else {
        this.block.funcionarios = false;
      }

      if (!this.novaAbono.id_tipo_abono) {
        this.block.tipoAbono = true;
        status = false;
      } else {
        this.block.tipoAbono = false;
      }

      return status;
    },
  },
  watch: {
    "novaAbono.todos"(value) {
      if (value) {
        this.novaAbono.funcionarios = [];
      }
    },
    searchQuery() {
      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => this.listarAbonos(), 800);
    },
    perPageOptions(value) {
      this.pagination.perPage = value;
    },
  },
};
</script>

<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
body {
  font-family: "Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", Helvetica, Arial,
    sans-serif;
}
</style>
